import React from 'react'
import { useTranslation } from '@mc/i18n'
import { Table, TableFeature, TableHeader } from '@mc/plans-ui'
import {
  DevicesFeature,
  OfflineDownloadFeature,
  PricingFeature,
} from '../../../../../components/Matrix/features'
import { CHECKOUT_I18N_NAMESPACE } from '../../../../../i18n'
import { useMCProCertsCatalogValue } from '../../../hooks/useMCProCertsCatalogValue'
import { MC_PRO_TIER_I18N_NAMESPACE } from '../../../i18n'
import { CertificatesFeature } from '../../CertificatesFeature'
import { Header } from './Header'

export const Matrix = () => {
  const { t } = useTranslation(MC_PRO_TIER_I18N_NAMESPACE)
  const { t: tCheckout } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const value = useMCProCertsCatalogValue()

  return (
    <Table label={tCheckout('plans.label')}>
      <TableHeader.Header>
        <Header />
      </TableHeader.Header>

      <TableFeature.FeatureList>
        <PricingFeature />
        <CertificatesFeature
          title={t('matrix.certificates.annualPass.title')}
          description={
            value
              ? t('matrix.certificates.annualPass.description', { value })
              : t('matrix.certificates.annualPass.descriptionWithoutValue')
          }
          values={['notIncluded', 'notIncluded', 'included']}
        />
        <DevicesFeature />
        <OfflineDownloadFeature />
      </TableFeature.FeatureList>
    </Table>
  )
}
